import { Group, Text, Box } from '@mantine/core';

const UserInfoRow = ({ icon: Icon, value, label, iconColor = '#f20a61', compact = false, lineClamp }) => (
  <Group wrap="nowrap" spacing={compact ? 'xs' : 'md'} align="flex-start" gap={compact ? 8 : undefined}>
    <Box miw={compact ? 22 : 28} mt={compact ? 2 : 3}>
      <Icon size={compact ? 16 : 20} color={iconColor} />
    </Box>
    <Box style={{ minWidth: 0, flex: 1 }}>
      <Text
        size={compact ? 'sm' : 'md'}
        fw={600}
        ta="left"
        lineClamp={lineClamp}
        title={lineClamp && value ? String(value) : undefined}
      >
        {value}
      </Text>
      <Text size="xs" c="dimmed" ta="left" lh={compact ? 1.2 : undefined}>
        {label}
      </Text>
    </Box>
  </Group>
);

export default UserInfoRow;